import {FETCH_PROJECT_SUMMARY, FETCH_PROJECT_LIST} from "../actions/ProjectAction"

const projectReducer = (state = {projectId: "", massGroupSummaries: [], projectsList: []}, action) => {

    switch (action.type) {

        case FETCH_PROJECT_SUMMARY:

            return {
                ...state,
                projectId: action.projectId,
                massGroupSummaries: action.massGroupSummaries
            };
        case FETCH_PROJECT_LIST:

            return {
                ...state,
                projectsList: action.projectsList
            };
        default:
            return state;
    }
};

export default projectReducer